import React from 'react';
import {PageContentWrapper} from "../../shared/styled/PageContentStyle";
import Title from "./Title";
import Content from "./Content";

const UserList = () => {
	return (
		<PageContentWrapper>
			<Title/>
			<Content />
		</PageContentWrapper>
	);
}

export default UserList;